export default "__VITE_ASSET__32ECusy$__"